/**
 * Contratos zod del endpoint Series.
 */

import { z } from 'zod';
import { TENENCIAS_SERIE } from '@/domain/types';

export const TenenciaSerieSchema = z.enum(TENENCIAS_SERIE);

export const PickeoEnSchema = z.object({
  pickeoId: z.string().min(1),
  usuarioId: z.string().min(1),
  ts: z.string().datetime(),
});

export const SerieSchema = z.object({
  id: z.string().min(1),
  gtin: z.string().regex(/^\d{14}$/),
  lote: z.string().min(1),
  vencimiento: z.string().regex(/^\d{2}\/\d{4}$/, 'Vencimiento debe ser MM/YYYY'),
  tenencia: TenenciaSerieSchema,
  ubicacionActualId: z.string().nullable(),
  createdAt: z.string().datetime(),
  altaManual: z.boolean().optional(),
  ingresoId: z.string().optional(),
  pickeoEn: PickeoEnSchema.optional(),
});

export const GetSeriesResponse = z.array(SerieSchema);

export type Serie = z.infer<typeof SerieSchema>;
